import { DEVICES } from '_constants';
import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  max-width: calc(60%);
  width: 100%;
  max-height: 80vh;
  overflow: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media ${DEVICES.laptopL} {
    max-width: calc(90%);
  }
`;

export const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;

  &:hover {
    color: #374151;
  }
`;

export const ModalBody = styled.div`
  padding: 20px;
`;

export const JsonDisplay = styled.pre`
  background-color: #f3f4f6;
  padding: 16px;
  border-radius: 6px;
  overflow: auto;
  font-size: 13px;
  line-height: 1.6;
  margin: 0;
  font-family: 'Courier New', Courier, monospace;
`;
